import Card from './Card';
import { FIAT_TRANSACTION_STATES } from './globals';
import { IPFS_ENDPOINT } from '@utils/globals';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

const HeaderDiv = styled.div(({ theme }) => ({
    display: 'block',
    margin: theme.spacing.xxs,
    [theme.mediaQuery.tabletLandscapeUp]: {
        display: 'flex',
        justifyContent: 'space-between'
    }
}));

const TemplateContainerDiv = styled.div(({ theme }) => ({
    display: 'block',
    marginTop: theme.spacing.xxs,
    [theme.mediaQuery.tabletLandscapeUp]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)'
    }
}));

const TemplateDiv = styled.div(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing.xxs
}));

const TemplateImg = styled.img(({ theme }) => ({
    width: theme.size.templateWidth,
    height: theme.size.templateHeight,
    objectFit: 'contain'
}));

const HeaderItemP = styled.p(({ theme }) => ({
    marginBottom: theme.spacing.xxs
}));

function FiatTransactionCard({ transaction, packInfos = [], packsImages={} }) {
    const theme = useTheme();

    const customCardStyle = {
        backgroundColor: FIAT_TRANSACTION_STATES[transaction.status].backgroundColor ? FIAT_TRANSACTION_STATES[transaction.status].backgroundColor : 'unset',
        padding: theme.spacing.xxs,
        minHeight: 80,
        display: 'block'
    };

    const renderStatus = () => {
        let color = FIAT_TRANSACTION_STATES[transaction.status].color ? FIAT_TRANSACTION_STATES[transaction.status].color : 'unset';
        let status = <b style={{ color: color }}>{FIAT_TRANSACTION_STATES[transaction.status].label}</b>;
        if (transaction.status === FIAT_TRANSACTION_STATES.pay_pending.key && transaction.redirect) {
            status = <>{status} <a href={transaction.redirect}>Approve Payment</a></>;
        }
        return status;
    };

    const renderTemplates = () => {
        return transaction.templates.map((template) => {
            const templateObj = packInfos.filter(x => `${x.template_id}` === template.template_id)[0];
            const img = packsImages[template.template_id] ? packsImages[template.template_id].imgHash : "";
            return templateObj ?
                <TemplateDiv>
                    <TemplateImg src={`${IPFS_ENDPOINT}${img}`} />
                    <p>{template.qnt} x {templateObj.name}</p>
                </TemplateDiv>
                : null
            ;
        });
    };

    return (
        <Card style={customCardStyle}>
            <HeaderDiv>
                <HeaderItemP><b>Transaction: </b>{transaction.transaction_id}</HeaderItemP>
                <HeaderItemP><b>Recipient Account: </b>{transaction.account_name}</HeaderItemP>
                <HeaderItemP>{renderStatus()}</HeaderItemP>
            </HeaderDiv>
            <hr />
            <TemplateContainerDiv>
                {renderTemplates()}
            </TemplateContainerDiv>
            <div />
        </Card>
    );
}

export default FiatTransactionCard;
